import React, { useCallback, useMemo } from 'react';
import { TbLayout, TbLayoutGrid, TbLayoutList } from 'react-icons/tb';
import { useLayoutContext } from '../../Contexts/LayoutContext';

interface ButtonsViewModeProps {
    className?: string;
}

const ButtonsViewMode = ({className}: ButtonsViewModeProps) => {

    const { viewMode, setViewMode, isMobile} = useLayoutContext();

    const viewModeList = useMemo(() => isMobile
        ? [
            { name: 'swiper', icon: <TbLayoutGrid size={20} /> },
            { name: 'swiper_image', icon: <TbLayout size={20} /> },
            { name: 'list', icon: <TbLayoutList size={20} /> },
        ]
        : [
            { name: 'list', icon: <TbLayoutList size={20} /> },
            { name: 'grid', icon: <TbLayoutGrid size={20} /> },
        ],
    [isMobile]);

    const getNextViewMode = useCallback((currentMode: string) => {
        const currentIndex = viewModeList.findIndex(item => item.name === currentMode);
        return viewModeList[(currentIndex + 1) % viewModeList.length]?.name || viewModeList[0].name;
    }, [viewModeList]);

    const nextViewMode = useMemo(() => getNextViewMode(viewMode), [viewMode, getNextViewMode]);

    return (
        <div className={`${className}`}>
            {viewModeList
                .filter((item: any) => item.name === nextViewMode)
                .map((mode: any, index: number) =>
                    <button
                        onClick={() => setViewMode(nextViewMode)}
                        type="button"
                        className="flex items-center rounded-lg bg-white p-3 text-gray-400 ring-1 ring-inset ring-gray-100 hover:bg-gray-50 focus:z-10"
                        key={index}
                        >
                        <span className='text-custom-primary zoomInIconNoDelay'>{mode.icon}</span>
                    </button>
            )}
        </div>
    );
};

export default ButtonsViewMode;
